import React, {Component} from 'react'
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap"
import {ReactComponent as IconHead2} from "../../../assets/icon/icon-head-2.svg"
import {DatePicker} from 'antd'
import {statisticPushedSku} from "../../../services/api/apiOrdersReport"
import moment from "moment"
import MultiSelect from '../MutilSelect'
import apiBarcode from '../../../services/api/apiBarcode'

const {RangePicker} = DatePicker

class StaticsCreatedPage extends Component {
    state = {
        loading: true,
        error: '',
        selectedDate: [moment().startOf('date'), moment()],
        //selectedDate: [moment().subtract('10', 'month'), moment()],
        payload: {
            sku: '',
        },
        filters: {
            type: [],
        },
        data: [],
    }

    componentDidMount() {
        this.responsive()
        const {selectedDate} = this.state
        this.setState({
                payload: {
                    ...this.state.payload,
                    time_from: moment(selectedDate[0]).startOf('date').format('HH:mm'),
                    time_to: moment(selectedDate[1]).format('HH:mm'),
                    date_from: moment(selectedDate[0]).startOf('date').format('DD/MM/YYYY'),
                    date_to: moment(selectedDate[1]).format('DD/MM/YYYY'),
                },
            }, () => apiBarcode
                .getFilters()
                .then(response => {
                    const {success, data, message} = response.data

                    if (!success) {
                        alert(message)
                    }

                    this.setState(prevState => ({filters: {...prevState.filters, ...data}}))
                })
                .catch(e => alert(e.message))
                .finally(async () => {
                    await this._fetchStaticsCreated()
                }),
        )
    }

    /**
     * Sample responsive on displaying columns
     */
    responsive = () => {
        const onResize = () => {
            const {dashboardStaticCreatedPageCols} = window
            let newV
            if (window.innerWidth < 700) {
                newV = 1
            } else if (window.innerWidth < 1000) {
                newV = 2
            } else {
                newV = 3
            }

            if (newV === dashboardStaticCreatedPageCols) {
                return
            }
            window.dashboardStaticCreatedPageCols = newV

            // Rerender
            setTimeout(() => {
                this.setState({time: Date.now()})
            })
        }
        window.addEventListener('resize', onResize)
        onResize()
    }

    _fetchStaticsCreated = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const {payload} = this.state
            const {data: response} = await statisticPushedSku(
                [
                    `time_from=${payload.time_from}`,
                    `time_to=${payload.time_to}`,
                    `date_from=${payload.date_from}`,
                    `date_to=${payload.date_to}`,
                    `sku=` + (payload.sku ? payload.sku.join(',') : ''),
                ].join('&'),
            )

            const {success, data, message} = response

            const newArray = []

            Object.keys(data).map((item) => {
                return newArray.push({sku: [item], value: data[item]})
            })

            if (!success) {
                return this.setState({
                    loading: null,
                    error: message,
                })
            }

            this.setState({
                loading: false,
                data: newArray,
            })
        } catch (e) {
            this.setState({
                loading: null,
                error: e.message,
            })
        }
    }

    _onDateChange = (dates) => {
        if (!!dates && dates.length === 2) {
            const time_from = moment(dates[0]).format('HH:mm')
            const time_to = moment(dates[1]).format('HH:mm')
            const date_from = moment(dates[0]).format('DD/MM/YYYY')
            const date_to = moment(dates[1]).format('DD/MM/YYYY')

            this.setState({
                payload: {
                    ...this.state.payload,
                    time_from,
                    time_to,
                    date_from,
                    date_to,
                },
            }, () => {
                this._fetchStaticsCreated()
            })
        } else {
            this._fetchStaticsCreated()
        }
    }

    onChange = (prop) => (value) => {
        if (prop === 'date') {
            return this._onDateChange(value)
        }

        this.setState({
            payload: {
                ...this.state.payload,
                [prop]: value,
            },
        }, () => {
            this._fetchStaticsCreated()
        })
    }
    
    render() {
        const {
            selectedDate,
            data,
            loading,
            filters,
        } = this.state
        const maxCols = window.dashboardStaticCreatedPageCols || 3
        const numCols = Math.min(data.length, maxCols)
        const numRows = numCols < maxCols ? 1 : Math.ceil(data.length / maxCols)
        const message = (() => {
            return (!data || !data.length) && !loading
                ? 'No data'
                : (loading && 'Loading...')
        })()

        return (
            <Row className="text-center" data-key={this.state.time}>
                <Col md={12}>
                    <div className="StaticsCreatedPage">
                        <Card>
                            <CardHeader className="CardHeader text-white header-elements-inline">
                                <h2 className="card-title d-flex align-items-center">
                                    <IconHead2/>
                                    Thống kê số lượng hàng hóa theo thời gian
                                </h2>
                            </CardHeader>
                            <CardBody>
                                <div className="row">
                                    <div className="SearchDateTime d-flex align-items-center mr-0">
                                        <span>Thời gian</span>
                                        <div className="DatePicker">
                                            <RangePicker
                                                defaultValue={selectedDate}
                                                showTime={{format: 'HH:mm'}}
                                                format="HH:mm - DD/MM/YYYY"
                                                onChange={this.onChange('date')}
                                            />
                                        </div>

                                    </div>
                                    <Col md={6} className="FilterSku">
                                        <MultiSelect
                                            lists={filters.type}
                                            placeholder="Chọn loại sản phẩm"
                                            value={[]}
                                            allowClear={true}
                                            // field={'Loại sản phẩm'}
                                            onChange={this.onChange('sku')}
                                        />
                                    </Col>
                                </div>
                                {
                                    message && <p>{message}</p>
                                }
                                {
                                    !message &&
                                    <div className="TableStatics justify-content-between" data-cols={maxCols}>
                                        {
                                            Array.from({length: maxCols}).map((_undef, colIndex) => {
                                                return <div key={colIndex}>
                                                    <div className="StaticsTableCreated">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                            <tr>
                                                                <th className="SKU text-left">SKU</th>
                                                                <th className="Quantity">Số lượng</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {
                                                                Array.from({length: numRows}).map((_undef, rowIndex) => {
                                                                    const dataCol = data[colIndex * numRows + rowIndex]
                                                                    const {sku, value} = {...dataCol}

                                                                    return <tr>
                                                                        <td className={[`SKU text-left`, !sku && 'no-data'].filter(Boolean).join(' ')}>{sku && `${sku}` || '-'}</td>
                                                                        <td className={[`Quantity`, !sku && 'no-data'].filter(Boolean).join(' ')}>{sku ? `${value}` : '-'}</td>
                                                                    </tr>
                                                                })
                                                            }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </div>
                                }
                            </CardBody>
                        </Card>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default StaticsCreatedPage
